module.exports = __webpack_public_path__ + "img/icon_benefit_01_w.af99eaf7.svg";